<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div class="flex  align-items marginBottom20">
          <div class="flex align-items marginRight10 marginBottom10">
            <!-- <span class="span marginRight10">优惠券名称: </span> -->
            <div class="width300">
              <el-input
                v-model="searchData.name"
                placeholder="输入销售合伙人名称/销售合伙人手机号"
                @keyup.enter.native="handleSearch"
                clearable
                maxlength="20"
              ></el-input>
            </div>
          </div>

          <div class="flex align-items marginRight10 marginBottom10">
            <el-button
              size="medium"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              class="marginLeft10"
            >查询</el-button>
          </div>

          <div class="flex align-items marginRight10 marginBottom10">
            <el-button
              size="medium"
              type="info"
              icon="el-icon-refresh-right"
              @click="handleReset"
              class="marginLeft10"
            >重置</el-button>
          </div>
        </div>
      </template>
      <template
        slot="menu"
        slot-scope="{ row }"
      >
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="handleEdit(row)"
        >编辑</el-button>
      </template>
    </avue-crud>

    <el-dialog
      v-if="dialogVisible"
      :title="form.id ? '编辑' : '新建'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <avue-form
        ref="form"
        v-model="form"
        :option="formOption"
        @submit="submit"
      >
        <template slot="partnerConsumePrice">
          <el-input-number
            v-model="form.partnerConsumePrice"
            :disabled="disabled"
            placeholder="请输入"
            :precision="2"
            size="large"
            :max="999999.99"
            :min="0"
            :controls="false"
          ></el-input-number>
        </template>
        <template slot="partnerGetIntegral">
          <el-input-number
            v-model="form.partnerGetIntegral"
            :disabled="disabled"
            size="large"
            placeholder="请输入"
            :precision="0"
            :max="999999"
            :min="0"
            :controls="false"
          ></el-input-number>
        </template>
        <template slot="menuForm">
          <el-button
            icon="el-icon-close"
            @click="handleClose"
          >取消</el-button>
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import { giveList, giveUpdate } from "@/api/setting/index";
export default {
  name: "index",
  data() {
    return {
      disabled: false,
      searchData: {
        title: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      option: {
        title: "好友裂变赠送设置",
        titleSize: "h3",
        card: true,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "销售合伙人",
            prop: "partnerUsername",
          },
          {
            label: "销售合伙人手机号",
            prop: "partnerPhone",
          },
          {
            label: "赠送裂变好友优惠券",
            prop: "couponName",
          },
          {
            label: "裂变好友每消费金额（元）",
            prop: "partnerConsumePrice",
          },
          {
            label: "销售合伙人获得积分",
            prop: "partnerGetIntegral",
          },
        ],
      },

      dialogVisible: false,
      form: {
        id: "",
        partnerConsumePrice: "",
        partnerGetIntegral: "",
      },
      formOption: {
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "200",
        column: [
          {
            label: "裂变好友每消费金额(元)",
            prop: "partnerConsumePrice",
            span: 50,
            rules: [
              {
                required: true,
                message: "请输入裂变好友每消费金额",
                trigger: "blur",
              },
            ],
          },
          {
            label: "销售合伙人获得积分",
            prop: "partnerGetIntegral",
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入销售合伙人获得积分",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  created() {
    const searchForm = JSON.parse(localStorage.getItem("searchForm"));
    if (searchForm?.path === this.$route.path) {
      this.searchData = searchForm.searchData;
    } else {
      localStorage.removeItem("searchForm");
    }
  },
  methods: {
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      localStorage.removeItem("searchForm");
      // console.log('重置')
      this.searchData = {
        name: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 新增编辑
    submit(form, done) {
      let datas = {
        id: this.form.id,
        partnerConsumePrice: this.form.partnerConsumePrice,
        partnerGetIntegral: this.form.partnerGetIntegral,
      };
      giveUpdate({
        ...datas,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("修改成功!");
            this.onLoad();
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetForm();
            }, 500);
          } else {
            this.$message.error(res.msg);
            done();
          }
        })
        .catch(() => {
          done();
        });
    },
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      localStorage.setItem("searchForm", JSON.stringify(searchForm));
      this.showLoading = true;
      giveList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    // 添加
    handleCreate() {
      this.$router.push({
        path: "/home/banner/create",
        query: {
          type: "create",
        },
      });
    },
    handleEdit(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deletePhone({
          id: row.id,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        servicePhone: "",
      };
    },
  },
};
</script>

<style scoped>
    /deep/.el-table .cell {
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 21px!important;
    padding-right: 10px;
}
</style>
